import { NavLink } from 'react-router-dom'
import LayoutDashboard from 'lucide-react/dist/esm/icons/layout-dashboard'
import Network from 'lucide-react/dist/esm/icons/network'
import BarChart3 from 'lucide-react/dist/esm/icons/bar-chart-3'
import Share2 from 'lucide-react/dist/esm/icons/share-2'
import { cn } from '@/lib/utils'

const preloadRoute = (path: string) => {
  if (typeof window === 'undefined') return
  const loaders: Record<string, () => void> = {
    '/dashboard': () => void import('@/pages/Dashboard'),
    '/network': () => void import('@/pages/Network'),
    '/stats': () => void import('@/pages/Stats'),
    '/share': () => void import('@/pages/Share'),
  }
  loaders[path]?.()
}

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/network', label: 'Network', icon: Network },
  { to: '/stats', label: 'Stats', icon: BarChart3 },
  { to: '/share', label: 'Share', icon: Share2 },
]

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background">
      <div className="mx-auto flex max-w-md items-center justify-around py-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onMouseEnter={() => preloadRoute(item.to)}
            onFocus={() => preloadRoute(item.to)}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 px-3 py-1 text-xs transition-colors',
                isActive
                  ? 'text-primary font-semibold'
                  : 'text-muted-foreground'
              )
            }
          >
            <item.icon className="h-5 w-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
